import React from 'react'
import { LucideIcon, AlertTriangle } from 'lucide-react'
import { BaseState } from './BaseState'

export interface ErrorStateProps {
  icon?: LucideIcon
  title?: string
  description: string
  action?: React.ReactNode
  className?: string
}

export function ErrorState({ 
  icon = AlertTriangle, 
  title = 'Unable to load data', 
  description, 
  action,
  className = '' 
}: ErrorStateProps) {
  return (
    <BaseState
      icon={icon}
      title={title}
      description={description}
      action={action}
      className={className}
      iconClassName="text-orange-600 dark:text-orange-400"
      iconContainerClassName="bg-orange-100 dark:bg-orange-900/20"
    />
  )
}
